import React from 'react';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { grey } from '@mui/material/colors';

const PREFIX = 'LoaderButton';

const classes = {
  root: `${PREFIX}-root`,
  wrapper: `${PREFIX}-wrapper`,
  buttonSuccess: `${PREFIX}-buttonSuccess`,
  fabProgress: `${PREFIX}-fabProgress`,
  buttonProgress: `${PREFIX}-buttonProgress`
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    alignItems: 'center'
  },

  [`& .${classes.wrapper}`]: {
    position: 'relative',
    width: '100%'
  },

  [`& .${classes.buttonSuccess}`]: {
    backgroundColor: grey[500],
    '&:hover': {
      backgroundColor: grey[700]
    }
  },

  [`& .${classes.fabProgress}`]: {
    color: grey[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },

  [`& .${classes.buttonProgress}`]: {
    color: '#a3a3a3',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

class CircularIntegration extends React.Component<any, any> {
  render() {
    const buttonClassname = classNames({
      [classes.buttonSuccess]: false
    });

    return (
      <Root className={classes.root}>
        <div className={classes.wrapper}>
          <Button
            variant='contained'
            color='primary'
            className={buttonClassname}
            disabled={this.props.disabled || this.props.isLoading}
            type='submit'
            fullWidth
            sx={{
              background: '#e5e5e5',
              color: '#0a0a0a',
              padding: '11px 28px',
              fontSize: '13px',
              fontWeight: 600,
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              borderRadius: '10px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
                transition: 'left 0.5s ease',
              },
              '&:hover': {
                background: '#ffffff',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.25)',
                transform: 'translateY(-1px)',
                '&::before': {
                  left: '100%',
                },
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
              },
              '&:disabled': {
                background: '#525252',
                color: 'rgba(255, 255, 255, 0.5)',
                boxShadow: 'none',
                border: '1px solid rgba(64, 64, 64, 0.3)',
              },
            }}
          >
            {!this.props.isLoading ? this.props.text : this.props.loadingText}
          </Button>
          {this.props.isLoading && <CircularProgress size={24} className={classes.buttonProgress} sx={{ color: '#0a0a0a' }} />}
        </div>
      </Root>
    );
  }
}

export default CircularIntegration;
